import file from "../../images/file.svg";
import url from "../../images/Page-1.svg";
import React, { useEffect, useState, useContext, useRef } from "react";
import send from "../../images/paper-plane.svg";
import cloud from "../../images/cloud-add.svg";
import Stack from "react-bootstrap/Stack";
import axios from "axios";
import Tick from "../../images/upload icon.svg";
import loading from "../../images/loading icon.svg";

const jsonData = [
  { id: 1, type: "file", name: "File 1.pdf", size: "2.5 MB" },
  { id: 2, type: "file", name: "File 2.pdf", size: "3.1 MB" },
  { id: 3, type: "file", name: "File 3.pdf", size: "1.8 MB" },
];

const urlData = [
  { id: 1, type: "url", name: "Webpage 1", link: "https://example.com/url1" },
  { id: 2, type: "url", name: "Webpage 2", link: "https://example.com/url2" },
  { id: 3, type: "url", name: "Webpage 3", link: "https://example.com/url3" },
];

const StackComponent = ({ data, type }) => {
  if (!Array.isArray(data)) {
    return <div style={{ margin: "12px" }}>No file available</div>;
  } else if (Array.isArray(data) && data.length === 0) {
    return <div style={{ margin: "12px" }}>No file available</div>;
  }
  return (
    <Stack
      gap={3}
      style={{ alignItems: "center", height: "30vh", overflowY: "auto" }}
    >
      {data &&
        data.map((item) => (
          <div
            style={{
              width: "90%",
              padding: "10px",
              borderRadius: "5px",
              backgroundColor: "#38393F",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {type == "Files" && <div>{item}</div>}

            {item.size && <div>{item.size}</div>}
            {type == "URLs" && (
              <a href={item} target="_blank" rel="noopener noreferrer">
                {extractUrlName(item)}
              </a>
            )}
          </div>
        ))}
    </Stack>
  );
};
const extractUrlName = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname; // Extract and return the hostname of the URL
  } catch (e) {
    return url; // If the URL is invalid, return the original URL
  }
};
const StatusComponent = ({ filestatus, urlstatus, type }) => {
  var status = type == "Files" ? filestatus : urlstatus;
  return (
    <Stack
      gap={3}
      style={{ alignItems: "center", height: "10vh", overflowY: "auto" }}
    >
      {status.map((item) => (
        <div
          style={{
            width: "90%",
            display: "flex",
            alignItems: "center",
            gap: "15px",
            padding: "5px",
            borderRadius: "5px",
            background: item.background,
          }}
        >
          <img
            src={item.iconSrc}
            alt={item.status}
            style={{ width: "24px", height: "24px", zIndex: "1" }} // Adjust size if needed
          />
          <div>
            <div
              style={{ fontSize: "10px", fontWeight: "400", color: "#FFFFFF" }}
            >
              {item.status}
            </div>
            <div style={{ fontSize: "8px", color: "#A9ACB4" }}>
              {item.description}
            </div>
          </div>
        </div>
      ))}
    </Stack>
  );
};
const Library = ({ prelist }) => {
  const [activeTab1, setActiveTab1] = useState("Files");
  const [message, setMessage] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [filestatus, setfilestatus] = useState([]);

  const [urlstatus, seturlstatus] = useState([]);
  const [list, setlist] = useState(prelist);
  const handleFileStatusUpdate = (newArray) => {
    setfilestatus((prevArray) => {
      const updatedArray = [...prevArray, ...newArray];
      // Do something with updatedArray if needed
      return updatedArray;
    });
  };

  const handleemptyfileStatusUpdate = () => {
    setfilestatus([]);
  };

  const handleurlStatusUpdate = (newArray) => {
    seturlstatus((prevArray) => {
      const updatedArray = [...prevArray, ...newArray];
      // Do something with updatedArray if needed
      return updatedArray;
    });
  };

  const handleemptyurlStatusUpdate = () => {
    seturlstatus([]);
  };

  const handlePaste = (event) => {
    event.preventDefault();
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    paste = paste.trim();
    setMessage(paste);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && message.trim() !== "") {
      event.preventDefault(); // Prevent default behavior (new line)
      //   handleSendButtonClick();
    }
  };

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    const pdfFiles = files.filter((file) => file.type === "application/pdf");
    if (pdfFiles.length !== files.length) {
      alert("Only PDF files are allowed.");
    }
    handleProcessButtonClick(pdfFiles);
    setSelectedFiles(pdfFiles);
  };

  const handleProcessButtonClick = async (pdfFiles) => {
    try {
      const formData = new FormData();
      pdfFiles.forEach((file) => {
        formData.append("file", file);
      });
      handleemptyfileStatusUpdate();

      let newArray = [
        {
          id: 1,
          iconSrc: Tick, // Icon for "Loading Completed"
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(237, 185, 0, 0.12) 0%, rgba(245, 134, 31, 0) 100%)",
          status: "Loading Completed",
          description: "Some dummy text here",
        },
        {
          id: 2,
          iconSrc: loading, // Icon for "Chunking In-Progress"
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(0, 237, 81, 0.12) 0%, rgba(0, 237, 123, 0) 100%)",
          status: "Chunking In-Progress",
          description: "Some dummy text here",
        },
      ];
      handleFileStatusUpdate(newArray);

      const response = await axios.post(
        "http://10.0.0.4:3016/uploadFiles",
        formData
      );

      setMessage("");

      // setfilestatus((prevArray) => [...prevArray, ...newArray]);

      if (response.data.status_code == 200) {
        newArray = [
          {
            id: 1,
            iconSrc: Tick, // Icon for "Loading Completed"
            background:
              "radial-gradient(50% 50% at 50% 50%, rgba(237, 185, 0, 0.12) 0%, rgba(245, 134, 31, 0) 100%)",
            status: "File uploaded successfully",
            description: "Some dummy text here",
          },
        ];

        handleFileStatusUpdate(newArray);
        setFileUploaded(true);
        setTimeout(() => {
          setFileUploaded(false);
        }, 2000);
      } else {
        throw new Error("File upload failed");
      }
    } catch (error) {
      console.error("Error occurred while uploading files:", error);
    }
  };
  const handleurlsendClick = async () => {
    const endpoint = "http://10.0.0.4:3016/upload-url";
    let request = { url: message };
    handleemptyurlStatusUpdate();
    try {
      // Initially set "URL added" status
      let newArray = [
        {
          id: 1,
          iconSrc: Tick, // Icon for "Loading Completed"
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(237, 185, 0, 0.12) 0%, rgba(245, 134, 31, 0) 100%)",
          status: "URL added",
          description: "Some dummy text here",
        },
        {
          id: 2,
          iconSrc: loading, // Icon for "Chunking In-Progress"
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(0, 237, 81, 0.12) 0%, rgba(0, 237, 123, 0) 100%)",
          status: "Chunking In-Progress",
          description: "Some dummy text here",
        },
      ];
      handleurlStatusUpdate(newArray);
      // Send URL to backend
      const response = await axios.post(endpoint, request, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setMessage("");

      // Set "Chunking In-Progress" status after URL is successfully added

      const response_data = response.data;
      if (response_data.status_code == 200) {
        // Set "URL Embedding completed successfully" status after chunking is done
        setTimeout(() => {
          newArray = [
            {
              id: 3,
              iconSrc: Tick, // Icon for "Loading Completed"
              background:
                "radial-gradient(50% 50% at 50% 50%, rgba(237, 185, 0, 0.12) 0%, rgba(245, 134, 31, 0) 100%)",
              status: "URL Embedding completed successfully",
              description: "Some dummy text here",
            },
          ];
          handleurlStatusUpdate(newArray);
        }, 2000); // Adjust the timeout duration as needed
      } else {
        throw new Error("URL embedding failed");
      }
    } catch (error) {
      console.error("Error occurred while uploading URL:", error);
    }
  };

  // seturlstatus((prevArray) => [...prevArray, ...newArray]);

  // seturlstatus((prevArray) => {
  //   const updatedArray = [...prevArray, ...newArray];
  //   return updatedArray;
  // });

  const handletabclick = async (type) => {
    var endpoint = "";
    if (type == "Files") {
      setActiveTab1("Files");
      endpoint = "http://10.0.0.4:3016/fileslist";
    } else {
      setActiveTab1("URLs");
      endpoint = "http://10.0.0.4:3016/urllist";
    }
    const response = await axios.get(endpoint);
    console.log("******response response", response.data);

    const parsedObject =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;
    const result =
      type == "Files"
        ? parsedObject.response.filelist
        : parsedObject.response.urllist;
    console.log(result);
    setlist(result);
  };
  return (
    <div className="library-content">
      <div className="row">
        <div
          className="col-sm-8"
          style={{
            marginLeft: "40px",
            border: "0.92px solid #4E4E4E",
            height: "62vh",
            borderRadius: "10px",
            marginRight: "10px",
            alignItems: "center",
          }}
        >
          <div className="tab-container1">
            <div
              className={`tab1 ${activeTab1 === "Files" ? "active1" : ""}`}
              onClick={() => handletabclick("Files")}
            >
              <img src={file} alt="Chat Icon" className="tab-icon" />
              Files
            </div>
            <div
              className={`tab1 ${activeTab1 === "URLs" ? "active1" : ""}`}
              onClick={() => handletabclick("URLs")}
            >
              <img
                src={url}
                alt="Library Icon"
                style={{ marginTop: "3px", marginRight: "5px" }}
              />
              URLs
            </div>
          </div>
          {activeTab1 === "Files" ? (
            <div
              style={{
                border: "2px dashed #CBD0DC",
                height: "48%",
                width: "62%",
                borderRadius: "10px",
                marginLeft: "25%",
                backgroundColor: "#38393F",
                margin: "70px auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px",
                flexDirection: "column",
              }}
            >
              <img
                src={cloud}
                alt="cloud"
                style={{ width: "24px", height: "24px" }}
              />
              <div
                style={{
                  color: "white",
                  marginTop: "50px",
                  textAlign: "center",
                  fontweight: "500",
                  fontFamily: "Graphik",
                  fontSize: "15px",
                }}
              >
                Choose a file or drag & drop it here
              </div>
              <div
                style={{
                  color: "#A9ACB4",
                  fontSize: "8px",
                  marginTop: "7px",
                  textAlign: "center",
                }}
              >
                Upload in PDF formats, up to 10 MB
              </div>
              <input
                type="file"
                onChange={handleFileSelect}
                style={{ display: "none" }}
                id="file-upload"
              />
              <label
                htmlFor="file-upload"
                style={{
                  width: "35%",
                  height: "26%",
                  padding: "10px 22px",
                  borderRadius: "10px",
                  margin: "20px auto 0 auto",
                  background:
                    "linear-gradient(180deg, rgba(19, 22, 25, 0) 0%, #131619 100%)",
                  boxShadow: "0px 3px 20px 0px #A100FF33",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <p
                  style={{
                    fontFamily: "Graphik",
                    fontSize: "12px",
                    fontWeight: "500",
                    lineHeight: "12px",
                    textAlign: "center",
                    margin: 0,
                    color: "#FFFFFF",
                    background:
                      "linear-gradient(180deg, rgba(19, 22, 25, 0) 0%, #131619 100%)",
                  }}
                >
                  Browse File
                </p>
              </label>
            </div>
          ) : (
            <div className="row">
              <div
                className="col-sm-1"
                style={{ color: "white", marginTop: "10px" }}
              >
                Url
              </div>
              <div className="col-sm-11 chat-input-container1">
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onPaste={handlePaste}
                  onKeyDown={handleKeyDown}
                  placeholder="Type the url here"
                  className="chat-textarea1"
                />

                <img
                  src={send}
                  alt="Send"
                  onClick={handleurlsendClick}
                  className="send-icon1"
                />
              </div>
            </div>
          )}
        </div>
        <div className="col-sm-3">
          <div
            style={{
              border: "0.92px solid #4E4E4E",
              height: "40vh",
              borderRadius: "10px",
              marginRight: "10px",
            }}
          >
            <p
              style={{
                fontFamily: "Graphik",
                fontSize: "12px",
                fontWeight: "600",
                lineHeight: "20px",
                textAlign: "left",
                margin: "12px",
                color: "#9B9C9E",
              }}
            >
              {activeTab1 === "Files" ? "File List" : "URL List"}

              <div
                style={{
                  borderBottom: "0.86px solid #4E4E4E",
                  paddingTop: "10px",
                }}
              ></div>
            </p>
            <StackComponent data={list} type={activeTab1} />
          </div>
          <div
            style={{
              border: "0.92px solid #4E4E4E",
              height: "20vh",
              borderRadius: "10px",
              marginRight: "10px",
              marginTop: "10px",
            }}
          >
            <p
              style={{
                fontFamily: "Graphik",
                fontSize: "12px",
                fontWeight: "600",
                lineHeight: "18px",
                textAlign: "left",
                margin: "12px",
                color: "#9B9C9E",
              }}
            >
              Status
              <div
                style={{
                  borderBottom: "0.86px solid #4E4E4E",
                  paddingTop: "10px",
                }}
              ></div>
            </p>
            <StatusComponent
              filestatus={filestatus}
              urlstatus={urlstatus}
              type={activeTab1}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Library;
